module.exports = __webpack_public_path__ + "img/review-2.b064c583.png";